import {
  ButtonBase,
  Stack,
  Avatar,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useState } from "react";
import { KeycloakIdentity } from "../../providers/authProvider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  useGetIdentity,
  useLogout,
  useTranslation,
  useNavigation,
} from "@refinedev/core";

export const UserMenu = () => {
  const { data: user } = useGetIdentity<KeycloakIdentity>();
  const { translate } = useTranslation();
  const { push } = useNavigation();

  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorElement);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  const { mutate: logout } = useLogout();

  if (!user) {
    return null;
  }

  return (
    <>
      <ButtonBase
        TouchRippleProps={{
          style: {
            borderRadius: "8px",
            margin: "-4px",
          },
        }}
        onClick={handleOpen}
      >
        <Stack
          direction="row"
          gap="8px"
          alignItems="center"
          justifyContent="center"
        >
          <Avatar
            alt={user?.name + " " + user?.surname}
            sx={{ width: 32, height: 32, fontSize: 16 }}
            variant="rounded"
          >
            {user.name[0] + user.surname[0]}
          </Avatar>
          <Typography
            sx={{
              display: {
                xs: "none",
                sm: "inline-block",
              },
            }}
            variant="subtitle2"
          >
            {translate("pages.layout.welcomeMessage", { name: user.name })}
          </Typography>
          <KeyboardArrowDownIcon />
        </Stack>
      </ButtonBase>
      <Menu
        anchorEl={anchorElement}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{
          mt: 1,
          "& .MuiPaper-root": {
            minWidth: "200px",
          },
        }}
      >
        <MenuItem onClick={() => push("extension")}>
          <Typography sx={{ textAlign: "center" }}>
            {translate("pages.layout.extension")}
          </Typography>
        </MenuItem>
        <MenuItem onClick={() => logout()}>
          <Typography sx={{ textAlign: "center" }}>
            {translate("pages.layout.logout")}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
